import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { Inscats, EmailDomains, SysOptionReq, Postcodes, BuildAddrs, Codes, FlightScheduleReq, FlightSchedules, MortgageBank } from 'bff/models/info';
import { BaseRes } from 'bff/models/base/baseRes';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { SysOptions } from 'bff/models/info/sysoptions';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { ClaimPolicyNos, CorrectionAddReq, CorrectionAddRes, EndorseOpts } from 'bff/models/member';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

/**
 * @description 取得旅遊險初始化資料
 */
const fetchTravelInitSetting = async (policyNoReq: any) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const fetchPolicyNoReq = commonService.getApiReqData(policyNoReq);

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI),
    apiService.fetchEndorsePolicyNo(fetchPolicyNoReq, reqConfig)
  ]).then(([inscatRes, UICodeRes, policyInfosRes]) => {
    const inscatBaseRes: BaseRes<Inscats> = { ...inscatRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };
    const policyInfosBaseRes: BaseRes<ClaimPolicyNos> = { ...policyInfosRes };

    const res = {
      inscats: commonService.arrayTypeReturn(inscatBaseRes.TRANRS.INSURANCE_CATEGORY),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      policyInfos: commonService.arrayTypeReturn(policyInfosBaseRes.TRANRS.OPTION)
    };
    console.log(res)
    return res;
  });

  return result;
};

/**
 * @description 取得汽機車險初始化資料
 */
const fetchVehicleInitSetting = async (policyNoReq: any) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.MARRIAGE, SysOptType.VEHICLE_CV_TYPE]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);
  const fetchPolicyNoReq = commonService.getApiReqData(policyNoReq);

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchEmailDN(baseReq, reqConfig),
    apiService.fetchPostcode(baseReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.ENDORSE),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI),
    apiService.fetchEndorsePolicyNo(fetchPolicyNoReq, reqConfig)
  ]).then(([inscatRes, emailDomainsRes, postcodesRes, sysOptRes, endorseCodeRes, UICodeRes, policyInfosRes]) => {
    const inscatBaseRes: BaseRes<Inscats> = { ...inscatRes };
    const emailDomainsBaseRes: BaseRes<EmailDomains> = { ...emailDomainsRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const postcodesBaseRes: BaseRes<Postcodes> = { ...postcodesRes };
    const endorseBaseRes: BaseRes<Codes> = { ...endorseCodeRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };
    const policyInfosBaseRes: BaseRes<ClaimPolicyNos> = { ...policyInfosRes };

    const res = {
      inscats: commonService.arrayTypeReturn(inscatBaseRes.TRANRS.INSURANCE_CATEGORY),
      emailDomains: commonService.arrayTypeReturn(emailDomainsBaseRes.TRANRS.EMAILDN),
      postcodes: commonService.arrayTypeReturn(postcodesBaseRes.TRANRS.POSTCODE),
      marriageSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS.MARRIAGE)),
      endorseCodes: commonService.arrayTypeReturn(endorseBaseRes.TRANRS.CODES),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      vehicleCVTypeSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS.VEHICLE_CV_TYPE)),
      policyInfos: commonService.arrayTypeReturn(policyInfosBaseRes.TRANRS.OPTION)
    };
    return res;
  });

  return result;
};

/**
 * @description 取得住火險初始化資料
 */
const fetchFireInitSetting = async (policyNoReq: any) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const fetchPolicyNoReq = commonService.getApiReqData(policyNoReq);
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.YESNO, SysOptType.ENDORSE_I04]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchPostcode(baseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.ENDORSE),
    apiService.fetchMortgageBank(baseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI),
    apiService.fetchEndorsePolicyNo(fetchPolicyNoReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig)
  ]).then(([inscatRes, postcodesRes, endorseCodeRes, mortgageBanksRes, UICodeRes, policyInfosRes, sysOptRes]) => {
    const inscatBaseRes: BaseRes<Inscats> = { ...inscatRes };
    const postcodesBaseRes: BaseRes<Postcodes> = { ...postcodesRes };
    const endorseBaseRes: BaseRes<Codes> = { ...endorseCodeRes };
    const mortgageBankBaseRes: BaseRes<MortgageBank> = { ...mortgageBanksRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };
    const policyInfosBaseRes: BaseRes<ClaimPolicyNos> = { ...policyInfosRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };

    const res = {
      inscats: commonService.arrayTypeReturn(inscatBaseRes.TRANRS.INSURANCE_CATEGORY),
      postcodes: commonService.arrayTypeReturn(postcodesBaseRes.TRANRS.POSTCODE),
      endorseCodes: commonService.arrayTypeReturn(endorseBaseRes.TRANRS.CODES),
      mortgageBanks: commonService.arrayTypeReturn(mortgageBankBaseRes.TRANRS.BANK),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      policyInfos: commonService.arrayTypeReturn(policyInfosBaseRes.TRANRS.OPTION),
      yesnoSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS.YESNO)),
      fireHouseCertificateLinkSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS.ENDORSE_I04))
    };

    return res;
  });

  return result;
};

/**
 * @description 取得預覽頁初始化資料
 */
const fetchPreviewInitSetting = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.VEHICLE_CV_TYPE]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchPostcode(baseReq, reqConfig),
    apiService.fetchMortgageBank(baseReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([inscatRes, postcodesRes, mortgageBanksRes, sysOptRes, UICodeRes]) => {
    const inscatBaseRes: BaseRes<Inscats> = { ...inscatRes };
    const postcodesBaseRes: BaseRes<Postcodes> = { ...postcodesRes };
    const mortgageBankBaseRes: BaseRes<MortgageBank> = { ...mortgageBanksRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };

    const res = {
      inscats: commonService.arrayTypeReturn(inscatBaseRes.TRANRS.INSURANCE_CATEGORY),
      postcodes: commonService.arrayTypeReturn(postcodesBaseRes.TRANRS.POSTCODE),
      mortgageBanks: commonService.arrayTypeReturn(mortgageBankBaseRes.TRANRS.BANK),
      vehicleCVTypeSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS.VEHICLE_CV_TYPE)),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES)
    };
    return res;
  });

  return result;
};

/**
 * @description 新增批改申請
 */
const AddCorrection = async (req: CorrectionAddReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.addCorrection(baseReq, reqConfig).then((res: BaseRes<CorrectionAddRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 查詢理賠保單號
 */
const fetchPolicyNo = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchEndorsePolicyNo(baseReq, reqConfig).then((res: BaseRes<ClaimPolicyNos>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.OPTION;
  }
};

/**
 * @description 查詢建築物地址選項清單
*/
const fetchBuildAddr = async (cityId: string, areaId: string) => {
  const baseReq = commonService.getApiReqData({ CITY_ID: cityId, AREA_ID: areaId });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchBuildAddr(baseReq, reqConfig).then((res: BaseRes<BuildAddrs>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return { ...res.TRANRS };
  }
};

/**
 * @description 取得批改變更項目
 */
const fetchEndorse = async (insTypeId: string, applyNo: string) => {
  const baseReq = commonService.getApiReqData({ INS_TYPE_ID: insTypeId, APPLY_NO: applyNo });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchEndorseOpts(baseReq, reqConfig).then((res: BaseRes<EndorseOpts>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 取得批改變更項目
 */
const fetchEndorseOpts = async (insTypeId: string, applyNo: string) => {
  const baseReq = commonService.getApiReqData({ INS_TYPE_ID: insTypeId, APPLY_NO: applyNo });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchEndorseOpts(baseReq, reqConfig).then((res: BaseRes<EndorseOpts>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return [...res.TRANRS.OPTION];
  }
};

/**
 * @description 取得航班資訊
 * @param flightDate 航班日期
 * @param carrierId 航班公司代碼
 * @param flightNo 航班編號
 */
const fetchFlightSchedule = async (flightDate: string, carrierId: string, flightNo: string) => {
  const flightScheduleReq: FlightScheduleReq = {
    FDATE: flightDate,
    CARRIER_ID: carrierId,
    FLIGHT_NO: flightNo
  };

  const baseReq = commonService.getApiReqData(flightScheduleReq);
  const reqConfig = commonService.getReqConfig();

  const res: BaseRes<FlightSchedules> = await apiService.fetchFlightSchedule(baseReq, reqConfig).then((res: BaseRes<FlightSchedules>) => res);

  switch (res.MWHEADER.RETURNCODE) {
    case ReturnCode.CodeParamFormatError:
      return res.TRANRS;
    case ReturnCode.CodeSuccess:
      return [...res.TRANRS.FLIGHT];
    default:
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: `無此航班資訊<br />(error code : ${res.MWHEADER.RETURNCODE})`
      });
      return res.TRANRS;
  }

  // return [
  //   {
  //     AIRLINE_ID: 'test',
  //     ARRIVAL_AIRPORT: 'CI',
  //     ARRIVAL_TIME: '2017-06-04 13:30:27',
  //     DEPARTURE_AIRPORT: 'ER',
  //     DEPARTURE_TIME: '2017-06-04 13:30:27',
  //     FLIGHT_NO: '799',
  //     FLIGHT_SEGMENT: '123',
  //   },
  //   {
  //     AIRLINE_ID: 'test',
  //     ARRIVAL_AIRPORT: 'CI',
  //     ARRIVAL_TIME: '2017-06-04 13:30:27',
  //     DEPARTURE_AIRPORT: 'ER',
  //     DEPARTURE_TIME: '2017-06-04 13:30:27',
  //     FLIGHT_NO: '799',
  //     FLIGHT_SEGMENT: '123',
  //   }
  // ]
};

export default {
  fetchTravelInitSetting,
  fetchVehicleInitSetting,
  fetchFireInitSetting,
  fetchPolicyNo,
  fetchBuildAddr,
  fetchEndorse,
  fetchEndorseOpts,
  fetchFlightSchedule,
  fetchPreviewInitSetting,
  AddCorrection
};
